import React, { useEffect, useState } from "react";
import gsap from "gsap";

import MainEEgg from "./main/main";
import Steps from "./steps/steps";
import Congratulations from "./congratulations/congratulations";

const EasterEgg = () => {

    const[step,setStep] = useState(0);
    const[modal,setModal] = useState(false);
    const[congrat,setCongrat] = useState(false)
    
    useEffect(() => {
        modal ? document.body.style.overflowY = "auto" : document.body.style.overflowY = "hidden"
        document.documentElement.style.setProperty("--mainColor", "white");
    })

    const startEEggHandler = () => gsap.to(".step-easter-egg",{ top:"0vh", duration:.5 })
    const openModalHandler = () => setModal(true)
    const nextStepHandler = () => {
        if(step < 5 ){
            setModal(false)
            const tl = gsap.timeline();
            tl.to(".fadeEgg",{opacity:0, duration:0.25, onComplete: () => setStep(prev => ++prev)})
            .to(".fadeEgg",{opacity:1, duration:1});

        }
        else{
            window.scrollTo(0,0);
            gsap.to(".step-easter-egg",{ top:"100vh", duration:.5 });
            setCongrat(true)
        }
    }

    return (
        <> 
            {congrat && <Congratulations />}
            <MainEEgg startHandler={startEEggHandler} />
            <Steps whatStep={step} nextStep={nextStepHandler} openModal={openModalHandler} isModalOpen={modal} />
        </>
    )
}

export default EasterEgg